import Config from "./Config";

export const endpoint =
  process.env.NODE_ENV === "production"
    ? `${Config.apis.backend}/api`
    : "http://localhost:5001/api";
